'use client';

import { ReactNode } from 'react';
import {
  HStack,
  VStack,
  Text,
  Divider,
  StackProps,
  DividerProps,
} from '@chakra-ui/react';

export interface InfoRowItem {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

export interface InfoRowProps extends StackProps {
  rows: InfoRowItem[];
  hasDivider?: boolean;
  dividerProps?: DividerProps;
}

export const InfoRow = (props: InfoRowProps) => {
  const { rows, hasDivider = true, dividerProps = {}, ...rest } = props;

  return (
    <VStack w="full" {...rest}>
      <HStack w="full" spacing="1rem" data-testid="giftcard-content-row">
        {rows.map(row => (
          <VStack
            key={row.key}
            align="flex-start"
            justify="flex-start"
            h="full"
            w="full"
          >
            <Text as="label" color="dynamic.accent" fontSize="0.9rem">
              {row.label}
            </Text>

            <Text as="span" fontSize="1.25rem">
              {row.value}
            </Text>
          </VStack>
        ))}
      </HStack>

      {hasDivider && <Divider {...dividerProps} />}
    </VStack>
  );
};
